import script from "./BaseSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=75a49e84&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a49e84"]])

export default __exports__